import { createStore } from '@aibees/shared/store';
import { LatestApiErrorStoreData as StoreData } from './types';

const useLatestApiErrorStore = createStore<StoreData>(
  'latest-api-error',
  (set) => ({
    error: undefined,
    setError: (error) => set({ error }),
  })
);

export default useLatestApiErrorStore;
